// TopShelf Aquarium Size Calculator
// Standard tank picker or custom dimensions -> gallons, liters, approx weight.
// Progressive enhancement: the dimensions chart and copy render without JS;
// this only powers the interactive picker.
document.addEventListener('DOMContentLoaded', function () {
  var select = document.getElementById('tsSizeSelect');
  var custom = document.getElementById('tsSizeCustom');
  var lEl = document.getElementById('tsSizeL');
  var wEl = document.getElementById('tsSizeW');
  var hEl = document.getElementById('tsSizeH');
  var result = document.getElementById('tsSizeResult');

  if (!select || !custom || !lEl || !wEl || !hEl || !result) {
    return;
  }

  function fmt(n) {
    return n.toLocaleString(undefined, { maximumFractionDigits: 1 });
  }

  function compute() {
    var L, W, H;

    if (select.value === 'custom') {
      custom.hidden = false;
      L = parseFloat(lEl.value);
      W = parseFloat(wEl.value);
      H = parseFloat(hEl.value);
    } else {
      custom.hidden = true;
      var parts = select.value.split(',');
      L = parseFloat(parts[0]);
      W = parseFloat(parts[1]);
      H = parseFloat(parts[2]);
    }

    if (!L || !W || !H || L <= 0 || W <= 0 || H <= 0) {
      result.innerHTML = '<p class="ts-size-hint">Choose a tank size or enter your dimensions to see volume and weight.</p>';
      return;
    }

    var gallons = (L * W * H) / 231;
    var liters = gallons * 3.78541;
    var waterLb = gallons * 8.34;
    var filledLb = gallons * 10; // rule of thumb including tank, rock and substrate

    result.innerHTML =
      '<ul class="ts-size-results">' +
      '<li><span>Volume</span><strong>' + fmt(gallons) + ' gal</strong></li>' +
      '<li><span>Volume</span><strong>' + fmt(liters) + ' L</strong></li>' +
      '<li><span>Water weight</span><strong>' + fmt(waterLb) + ' lb</strong></li>' +
      '<li><span>Approx. filled weight</span><strong>' + fmt(filledLb) + ' lb</strong></li>' +
      '</ul>' +
      '<p class="ts-size-note">Dimensions are in inches (length &times; width &times; height). Filled weight is approximate and includes water plus a typical tank, rock and substrate.</p>';
  }

  select.addEventListener('change', compute);
  [lEl, wEl, hEl].forEach(function (el) {
    el.addEventListener('input', compute);
  });

  compute();
});
